import { Component } from '@grafikr/components';

export default Component((node) => {
  const { height } = node.getBoundingClientRect();
  const navigationContainer = node.querySelector('[data-navigation-container]');

  const setHeaderVariable = (height: number) => {
    document.documentElement.style.setProperty('--header-height', `${height}px`);
  };

  setHeaderVariable(height);

  if (navigationContainer) {
    const { height: navigationHeight } = navigationContainer.getBoundingClientRect();

    document.documentElement.style.setProperty(
      '--header-height-main',
      `${height - navigationHeight}px`,
    );
  }
});
